<script>
  import { tausender_trenner } from "./UtilsBalkenProgress.svelte";
  import { find_help_text_if_exists } from "./Utils.svelte";

  export let active_animals;
  export let active_animals_target;
  export let marketing_end_date;
  export let helptexts;
  export let in_show_helptext_id;

  let hoehe = 400;
  function calc_down_heigth(active_animals, active_animals_target) {
    if (active_animals_target > active_animals) {
      return (active_animals / active_animals_target) * hoehe;
    } else {
      return (active_animals_target / active_animals) * hoehe;
    }
  }

  function calc_up_heigth(active_animals, active_animals_target) {
    if (active_animals_target > active_animals) {
      return ((active_animals_target - active_animals) / active_animals_target) * hoehe;
    } else {
      return ((active_animals - active_animals_target) / active_animals) * hoehe;
    }
  }

  function return_down_color() {
    return "#afcb08";
  }

  function return_up_color() {
    if (active_animals_target < active_animals) {
      return "#afcb08";
    } else {
      return "";
    }
  }

  function upper_text(active_animals_target) {
    if (active_animals_target > active_animals) {
      return active_animals_target;
    }
    return "";
  }

  function lower_text(active_animals) {
    if (active_animals_target > active_animals) {
      return active_animals;
    } else {
      return "";
    }
  }
</script>

<div class="card h-100" style="margin-bottom: 0px!important;">
  <div class="card-header text-center d-flex justify-content-between align-items-center">
    <h5 class="card-title">Total active boluses {marketing_end_date.toISOString().substring(0, 10)}</h5>
    <div class="info-circle my-auto">
      <div class="my-auto info-i">i</div>
      <div class="info-box" style="color: #000000;">
        {#if find_help_text_if_exists(helptexts, "marketing_mirror_active_animal_balken_1")}
          {@html find_help_text_if_exists(helptexts, "marketing_mirror_active_animal_balken_1")}
        {:else}
          <p>
            This chart shows the <strong>number of active boluses</strong> at the end of the reporting timeframe compared to the
            <span style="color: #51c3f9;"><strong>target number</strong></span> at the end of the year of the reporting timeframe.
          </p>
          <p>
            <span style="color: #7c706b;"
              >Please note that both the target number and the number of active boluses are limited to the countries selected under
              &ldquo;Select lead countries&rdquo;.</span
            >
          </p>
        {/if}
        {#if in_show_helptext_id}
          <div style="font-size: 7px">id: marketing_mirror_active_animal_balken_1</div>
          <div style="font-size: 7px">
            [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
          </div>
        {/if}
      </div>
    </div>
  </div>

  <div class="card-body outer" style="padding-top:0px;">
    <div style="margin: 20px;">
      <table height="{600}px;" class="inner">
        {#if active_animals_target > active_animals}
          <tr class="hoverclass" style="text-align: center; color: #51c3f9;" height="20px;"
            >Target <div class="info-box-auf-hoehe">
              {#if find_help_text_if_exists(helptexts, "marketing_mirror_active_animal_balken_2")}
                {@html find_help_text_if_exists(helptexts, "marketing_mirror_active_animal_balken_2")}
              {:else}
                <p>
                  <span style="color: #51c3f9;">Target</span> &hellip; Target for active boluses at the end of the year of the selected
                  timeframe for all selected countries.<br />If YTD is selected: Target for active boluses at the end of the current year
                  for all selected countries.<br /><br /><span style="color: #7c706b;"
                    >Example: {tausender_trenner(upper_text(active_animals_target))} means that the target for the number of active boluses at
                    the end of the selected year in the selected countries is {tausender_trenner(upper_text(active_animals_target))}.</span
                  >
                </p>
              {/if}
              {#if in_show_helptext_id}
                <div style="font-size: 7px">id: marketing_mirror_active_animal_balken_2</div>
                <div style="font-size: 7px">
                  [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                </div>
              {/if}
            </div></tr
          >
          <tr style="text-align: center; color: #51c3f9;" height="20px;">
            {tausender_trenner(upper_text(active_animals_target))}
            <!-- <div class="small_text">(dummy)</div> -->
          </tr>
        {/if}

        <tr style="text-align: center;" height="{calc_up_heigth(active_animals, active_animals_target)}px;">
          <div
            style="margin-top: 0px; color: #FFFFFF; {active_animals < active_animals_target
              ? 'border-width: 3px 3px 0px 3px;'
              : ''} border-color: #d7e2dc; {active_animals < active_animals_target
              ? 'border-style: solid;'
              : ''} background-color: {return_up_color()};"
            class="fill_heigth inner return_up_color() breite hoverclass"
          >
            {tausender_trenner(active_animals)}
            <!-- &nbsp; -->

            {#if active_animals > active_animals_target}
              <div class="info-box-auf-hoehe">
                {#if find_help_text_if_exists(helptexts, "marketing_mirror_active_animal_balken_3")}
                  {@html find_help_text_if_exists(helptexts, "marketing_mirror_active_animal_balken_3")}
                {:else}
                  <p>
                    <strong>Active boluses</strong> &hellip; Total number of active boluses in selected countries at the end of the
                    reporting timeframe.
                    <br /><em>If YTD is selected: current number of active boluses.</em>
                  </p>
                  <br /><br />
                {/if}
                {#if in_show_helptext_id}
                  <div style="font-size: 7px">id: marketing_mirror_active_animal_balken_3</div>
                  <div style="font-size: 7px">
                    [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                  </div>
                {/if}
              </div>
            {/if}
          </div>
        </tr>
        {#if active_animals > active_animals_target}
          <tr style="height:1px;"
            ><div
              style="height:100%; width:70px; border: solid #afcb08 2px; margin-left: auto; margin-right: auto; margin-top: 0px; margin-bottom: 0px;"
            /></tr
          >
        {/if}
        <tr class="hoverclass" style="text-align: center;" height="{calc_down_heigth(active_animals, active_animals_target)}px;">
          {#if active_animals <= active_animals_target}
            <div class="info-box-auf-hoehe">
              {#if find_help_text_if_exists(helptexts, "marketing_mirror_active_animal_balken_4")}
                {@html find_help_text_if_exists(helptexts, "marketing_mirror_active_animal_balken_4")}
              {:else}
                <p>
                  <strong>Active boluses</strong> &hellip; Total number of active boluses in selected countries at the end of the reporting
                  timeframe.
                  <br /><em>If YTD is selected: current number of active boluses.</em>
                </p>
                <br /><br />
              {/if}
              {#if in_show_helptext_id}
                <div style="font-size: 7px">id: marketing_mirror_active_animal_balken_4</div>
                <div style="font-size: 7px">
                  [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                </div>
              {/if}
            </div>
          {/if}

          <div
            style="margin-top: 0px; color: #FFFFFF; background-color:{return_down_color()};"
            class="fill_heigth inner breite {active_animals_target > active_animals ? 'border' : ''} "
          >
            {#if active_animals_target > active_animals}
              {tausender_trenner(lower_text(active_animals))}
            {:else}
              <div
                class="hoverclass"
                style="margin-top: 5px; margin-left:5px; margin-right:5px; background-color:#FFFFFF; opacity: 64%; color: #51c3f9;"
              >
                Target:
                {tausender_trenner(active_animals_target)}
                <div class="info-box-auf-hoehe">
                  {#if find_help_text_if_exists(helptexts, "marketing_mirror_active_animal_balken_5")}
                    {@html find_help_text_if_exists(helptexts, "marketing_mirror_active_animal_balken_5")}
                  {:else}
                    <p>
                      <span style="color: #51c3f9;">Target</span> &hellip; Target for active boluses at the end of the year of the selected
                      timeframe for all selected countries.<br />If YTD is selected: Target for active boluses at the end of the current
                      year for all selected countries.<br /><br /><span style="color: #7c706b;"
                        >Example: 368.000 means that the target for the number of active boluses at the end of the selected year in the
                        selected countries is 368.000.</span
                      >
                    </p>
                    <br /><br />
                  {/if}
                  {#if in_show_helptext_id}
                    <div style="font-size: 7px">id: marketing_mirror_active_animal_balken_5</div>
                    <div style="font-size: 7px">
                      [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                    </div>
                  {/if}
                </div>
              </div>
            {/if}
          </div>
        </tr>

        <tr style="text-align: center; height:7px; max-height:7px;" />

        <tr height="{20}px;" style="text-align: center; width:100px;">
          <td class="fill_heigth colored_text_field" style="height:20px; padding-right:5px; padding-left: 5px;"> Active BOLUSES </td>
        </tr>

        <tr height="{20}px;" style="text-align: center; width:110px;">
          <div class="" style="color: #455F51; font-size: 12px;">All sources</div>
        </tr>
      </table>
    </div>

    <div class="" style="padding:20px">
      <div class="col">
        <div class="row small-text">
          <div class="small-rect-1" />
          &nbsp;Target for number of active boluses for selected countries at the end of the year of the selected timeframe
        </div>
        <div class="row small-text">
          <div class="small-rect-2" style="background-color: #afcb08" />
          &nbsp;Total number of active boluses in selected countries at the end of the reporting timeframe
        </div>
      </div>
    </div>
  </div>
</div>

<style>
  .small-rect-1 {
    width: 10px;
    height: 10px;
    border: 1px solid grey;
    padding: 0px;
  }

  .small-rect-2 {
    width: 10px;
    height: 10px;
    border: 1px solid grey;
    padding: 0px;
  }

  .small-text {
    font-size: 9px;
  }

  .outer {
    width: 100%;
  }

  .inner {
    display: table;
    margin: 0 auto;
  }

  .fill_heigth {
    height: 100%;
  }

  .breite {
    width: 70px;
  }

  .colored_text_field {
    background-color: #afcb08;
    color: #ffffff;
    text-align: center;
    align-items: center;
  }
  tr {
    width: 70px;
  }

  .info-box-auf-hoehe {
    background: #ffffff;
    border: 0.25pt solid #d9d9d9;
    color: #000000;
    font-size: 12px;
    height: auto;
    width: auto;

    position: absolute;
    text-align: left;
    top: inherit;
    left: 200px;
    display: none;
    padding: 20px;
    z-index: 10;
    padding-bottom: 0px;
    padding-top: 15px;
  }

  .info-box {
    background: #ffffff;
    border: 0.25pt solid #d9d9d9;
    color: #000000;
    font-size: 12px;
    height: auto;
    width: 600;

    /*line-height: 10px;*/
    position: absolute;
    text-align: left;
    /*text-transform: uppercase;*/
    top: 50px;
    right: 50px;
    display: none;
    padding: 20px;
    z-index: 10;
    padding-bottom: 0px;
    padding-top: 15px;
  }

  .info-box:hover .info-box {
    display: block;
  }

  .info-circle {
    display: flex;
    justify-content: center;
    align-items: center;
    /*background-color: #eef3f0;*/
    border: 1px solid #999999;
    height: 25px;
    border-radius: 50%;
    width: 25px;
    text-align: center;
  }

  .info-circle:hover .info-box {
    display: block;
  }

  .info-circle:hover .info-i {
    display: none;
  }

  .hoverclass:hover .info-box {
    display: block;
  }

  .hoverclass:hover .info-i {
    display: none;
  }

  .info-box-auf-hoehe:hover .info-box-auf-hoehe {
    display: block;
  }

  .info-circle:hover .info-box-auf-hoehe {
    display: block;
  }

  .hoverclass:hover .info-box-auf-hoehe {
    display: block;
  }
</style>
